import { ReportType } from "../../../../../../api/types/svTypes.ts";
import { chartRelatedReportTypes } from "../../../../reporting/sv/utilities/chartRelatedReport.types.ts";

export const smartViewWidgetReportTypes = [
  ReportType.Pivot,
  ReportType.Tabular,
  ...chartRelatedReportTypes,
  ReportType.Tile,
];
